import { render, staticRenderFns } from "./bd.vue?vue&type=template&id=517e1155"
import script from "./bd.vue?vue&type=script&lang=js"
export * from "./bd.vue?vue&type=script&lang=js"
import style0 from "./bd.vue?vue&type=style&index=0&id=517e1155&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports